class LocalizationForm extends HTMLElement {
  constructor() {
    super()
    this.elements = {
      input: this.querySelector('input[name="language_code"], input[name="country_code"]'),
    }

    if (!this.elements.input) return

    // Find all links within this form and attach click handlers
    this.querySelectorAll("a").forEach((item) =>
      item.addEventListener("click", this.onItemClick.bind(this))
    )
  }

  onItemClick(event) {
    event.preventDefault()
    const form = this.querySelector("form")
    if (!form || !this.elements.input) return

    const value = event.currentTarget.dataset.value
    if (value) {
      this.elements.input.value = value
      form.submit()
    }
  }
}

if (!customElements.get("localization-form")) {
  customElements.define("localization-form", LocalizationForm)
}

export { LocalizationForm }
